import { paramCase } from 'change-case';
import { ManufacturerType } from 'b2b-apps/shop/manufacturer/redux/manufacturers/types';
import { ROUTES } from 'b2b-apps/shop/routes/components/Router';
import { useUrlCreator } from 'b2b-apps/shop/routes/hooks';

type UseGenerateManufacturerUrlReturnType = (manufacturer: ManufacturerType) => string;

const useGenerateManufacturerUrl = (): UseGenerateManufacturerUrlReturnType => {
  const urlCreator = useUrlCreator();

  return (manufacturer: ManufacturerType): string => {
    const manufacturerLink = paramCase(
      `${manufacturer.name} ${manufacturer.category} ${manufacturer.manufacturerId}`,
    );

    return urlCreator(
      ROUTES.manufacturer,
      { manufacturer: manufacturerLink },
    );
  };
};

export type { UseGenerateManufacturerUrlReturnType };
export { useGenerateManufacturerUrl };
